module.exports = __webpack_public_path__ + "img/logo2.73c00ac3.png";